import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { getVideoDetails } from "../../../api/endpoints/VideoEndpoints";

export default function useGetVideoDetails(videoId: string) {
  const getVideoDetailsFn = useCallback(() => {
    return getVideoDetails(videoId);
  }, [videoId]);

  return useQuery({
    queryKey: ["video", videoId],
    queryFn: getVideoDetailsFn,
  });
}
